import { ErrorState } from "../../../components/States";
import { Skeleton } from "../../../components/Skeleton";
import { useGetHealthTargetsQuery } from "../../../services";
import { HealthTargetsForm } from "./HealthTargetsForm";
import { toFormValues } from "./healthTargetsConfig";
import { Group, Header, Title } from "./styles";
import { HealthTargetsProps } from "./types";

export const HealthTargets = ({ focusMetric }: HealthTargetsProps) => {
  const { data: targets, isError, refetch } = useGetHealthTargetsQuery();

  const retry = async () => {
    await refetch();
  };

  const renderBody = () => {
    if (targets === undefined && isError) {
      return (
        <ErrorState
          message="We couldn't load your health targets."
          onRetry={retry}
        />
      );
    }
    if (targets === undefined) {
      return (
        <div aria-hidden="true">
          <Skeleton variant="rectangular" width="100%" height="160px" />
        </div>
      );
    }
    return (
      <HealthTargetsForm
        values={toFormValues(targets)}
        focusMetric={focusMetric}
      />
    );
  };

  return (
    <Group>
      <Header>
        <Title>Health targets</Title>
      </Header>
      {renderBody()}
    </Group>
  );
};
